module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-unknown-2.6ccfae15.svg";